<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">
      <v-row>
        <v-col cols="8">Klaim Order</v-col>
        <v-col cols="4 text-right d-none">
          <v-btn
            outlined
            class="text-subtitle-2 text-capitalize"
          >
          <v-icon center class="mr-2">mdi-download</v-icon> Unduh Laporan Penjualan
          </v-btn>
        </v-col>
      </v-row>
    </h2>

    <v-card outlined class="px-3 py-3">
      <v-tabs grow show-arrows v-model="intabs">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab>
        <template v-for="(status, idx) in filterStatus(statusPesanan)">
          <v-tab class="text-caption font-weight-bold" :key="idx">
            {{ statusCaption(status.trx_status) }}
            <v-chip
              small
              class="mx-2"
              color="green"
              text-color="white"
              v-if="status.count_status > 0"
            >
              {{ status.count_status }}
            </v-chip>
          </v-tab>
        </template>

        <v-tab-item>
          <klaimDataStokis :allowedStatus="allowedStatus" v-if="intabs === 0"></klaimDataStokis>
        </v-tab-item>

        <template v-for="(status, idlist) in filterStatus(statusPesanan)">
          <v-tab-item :key="idlist">
            <klaimDataStokis :allowedStatus="[status.trx_status]" v-if="intabs === (idlist + 2)"></klaimDataStokis>
          </v-tab-item>
      </template>

      </v-tabs>
    </v-card>

    
    <v-dialog
      v-model="dialogWaitPaymentList"
      persistent
      max-width="900"
    >
      <v-card>
        <v-card-title class="d-flex flex-column align-start text-left text-h6 text-capitalize black--text darken-4">
          Menunggu Persetujuan Stokis
          <div class="d-block text-caption grey--text">Pelanggan belum melakukan pembayaran atas item ini.</div>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5">
          <!-- <pesananBaruData :allowedStatus="['created']" v-if="dialogWaitPaymentList"></pesananBaruData> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              @click="dialogWaitPaymentList = false"
              class="my-2 px-5 text-capitalize"
            >
              Tutup
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import klaimDataStokis from './components/klaimOrderDataStokis'
// import pesananBaruData from './components/pesananBaruData'

export default {
  components: {
		klaimDataStokis, 
    // pesananBaruData
  },
  data() {
    return {
      intabs: null,
      status: [],
      allowedStatus: ['waiting_inquiry', 'waiting_approval', 'approved', 'completed', 'reject'], //'processed', 
      dialogWaitPaymentList: false,
      unpaid: 0,
      statusPesanan: [
        {
          trx_status: 'waiting_inquiry',
          count_status: '0'
        },
        {
          trx_status: 'waiting_approval',
          count_status: '1'
        },
        {
          trx_status: 'approved',
          count_status: '0'
        },
        {
          trx_status: 'reject',
          count_status: '0'
        },
        {
          trx_status: 'completed',
          count_status: '0'
        },
      ]
    }
  },
  computed: {
    // ...mapState('transaksiSeller', ['statusPesanan'])
  },
  methods: {
    // ...mapActions('transaksiSeller', ['getStatusPesanan']),

    statusCaption(status) {
      if (status === 'waiting_approval') return 'Menunggu Disetujui'
      else if (status === 'waiting_inquiry') return 'Menunggu Penawaran'
      else if (status === 'approved') return 'Diterima'
      else if (status === 'reject') return 'Ditolak'
      else if (status === 'completed') return 'Pesanan Selesai'
    },

    filterStatus(data) {
      if (data) {
        let showStatus = data.filter(d => this.allowedStatus.includes(d.trx_status))
        return showStatus
      }
    },
    getUnpaid() {
      const unpaidqty = this.statusPesanan.filter(d => ['created'].includes(d.trx_status))
      if (this.statusPesanan) this.unpaid = unpaidqty[0].count_status
      else this.unpaid = 0
    }
  },
  async created() {
    this.$store.dispatch('setPageTitle', `Pesanan Saya`);
    await this.getStatusPesanan()
    this.getUnpaid()
  },
}
</script>